/**
 * DarkMode service for handling dark mode functionality
 * Simplified to only manage Tailwind's dark class
 * Theme preferences are managed by preferencesStore
 */
export default {
  /**
   * Toggle dark mode
   * @returns {boolean} New dark mode state
   */
  toggle() {
    if (typeof document === "undefined") return false;
    const isDark =
      !!document.documentElement &&
      document.documentElement.classList.contains("dark");
    this.setDarkMode(!isDark);
    return !isDark;
  },

  /**
   * Set dark mode to a specific state
   * @param {boolean} enabled - Whether dark mode should be enabled
   */
  setDarkMode(enabled) {
    if (typeof document !== "undefined") {
      if (enabled) {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    }
    // Keep localStorage in sync for any legacy code
    if (typeof localStorage !== "undefined") {
      localStorage.setItem("darkMode", enabled ? "true" : "false");
    }
  },

  /**
   * Check if dark mode is currently enabled
   * @returns {boolean} Whether dark mode is enabled
   */
  isDarkMode() {
    if (typeof document === "undefined") return false;
    return (
      !!document.documentElement &&
      document.documentElement.classList.contains("dark")
    );
  },
};
